"use client";

import { ReactNode } from 'react';

import { FeatureFlags } from '@/enums/feature-flags';
import { useMultipleFeatureFlags } from '@/hooks/useFeatureFlag';

interface FeatureFlagProps {
  name: FeatureFlags;
  children: ReactNode;
  fallback?: ReactNode;
  inverted?: boolean;
}

const FeatureEnabled = ({ children }: { children: ReactNode }) => <>{children}</>;
const FeatureDisabled = ({ children }: { children: ReactNode }) => <>{children || null}</>;

/**
 * Component for conditional rendering based on feature flags
 */
export const Feature = ({
  name,
  children,
  inverted = false
}: FeatureFlagProps) => {
  const params = Array.isArray(name) ? name : [name];
  const flags = useMultipleFeatureFlags(params);
  
  const isEnabled: boolean = Object.values(flags).some((value) => value);

  const shouldRender = inverted ? !isEnabled : isEnabled;

  const childrenArray = Array.isArray(children) ? children : [children];

  const getByType = (type: any) =>
    childrenArray.find((child: any) => child && child.type === type);

  return shouldRender ? getByType(FeatureEnabled) : getByType(FeatureDisabled);
};

Feature.Enabled = FeatureEnabled;
Feature.Disabled = FeatureDisabled;
